import { createServerFn } from "@tanstack/react-start";
import { StuurCodeSchema, ControleerCodeSchema } from "./verificatie-schema";
import { stuurVerificatieCodeServer, controleerVerificatieCodeServer } from "./smsverificatie.server";

export const stuurVerificatieCode = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => StuurCodeSchema.parse(input))
  .handler(({ data }) => stuurVerificatieCodeServer(data));

export const controleerVerificatieCode = createServerFn({ method: "POST" })
  .inputValidator((input: unknown) => ControleerCodeSchema.parse(input))
  .handler(({ data }) => controleerVerificatieCodeServer(data));
